import $ from 'jquery'

$(() => {
  $('.welcome__container').click(() => {
    location.href = '/ueber-uns';
  });
});
